import { render, staticRenderFns } from "./toptanSiparis.vue?vue&type=template&id=c6422c6a&scoped=true"
import script from "./toptanSiparis.vue?vue&type=script&lang=js"
export * from "./toptanSiparis.vue?vue&type=script&lang=js"
import style0 from "./toptanSiparis.vue?vue&type=style&index=0&id=c6422c6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6422c6a",
  null
  
)

export default component.exports